import {getBrowserCookie} from '../../../client/common/persistence/browserCookieUtils'

function generateDefaultInitialShoppingAssistantState() {
  return {
    isLoading: false,
    isWriting: false,
    isDeleted: false,
    isError: false,
    messages: [],
    contractApproved: false,
    contractVersion: 1,
    contractApproveLoading: false,
    chatHistory: [],
    jwt: '',
    categoryId: '',
    isTermsOfUseModalOpen: false,
  };
}

function getUserFirstNameProperly(name) {
  if (!name || typeof name !== 'string') {
    return '';
  }

  return name?.
    toLocaleLowerCase('tr-TR')?.
    split(' ')?.
    map(word => {
      const firstChar = word?.charAt(0)?.toLocaleUpperCase('tr-TR');
      const rest = word?.slice(1);
      return firstChar + rest;
    })?.
    join(' ');
}

function shoppingAssistantReducer(state = generateDefaultInitialShoppingAssistantState(), action) {
  let newState;

  switch (action.type) {

    case 'SEND_MESSAGE': {
      const newMessage = action?.payload?.params?.message || ''
      const messages = [...state.messages, ...newMessage ? [{
        message: newMessage,
        outgoing: true,
      }] : []]

      newState = {
        ...state,
        messages,
        isWriting: true,
        isError: false,
        isDeleted: false,
        isButtonLoading: true,
      };
      break;
    }

    case 'SEND_MESSAGE_FULFILLED': {
      const {quickMessageList, conversations = null} = action?.payload?.response?.data || {}
      const {chatHistory = [], chat} = conversations || {}
      const {response, recommendedProducts, deepLinkUrl, url} = chat || {}
      const userName = getBrowserCookie('userInfo') ? getUserFirstNameProperly(getBrowserCookie('userInfo')?.fn || '') : ''
      const welcomeMessage = `Merhaba ${userName}, ben ihtiyaçlarınıza göre en uygun seçenekleri size sunmak için geliştirilmiş Hepsiburada'nın yapay zeka destekli alışveriş asistanı. Nasıl bir ürüne ihtiyacınız var?`
      const newChatHistory = []

      if (chatHistory?.length > 0) {
        chatHistory?.reverse().map(item => {
          newChatHistory.push({
            message: item?.message,
            outgoing: true,
          })
          newChatHistory.push({
            message: item?.response,
            products: item?.recommendedProducts,
            url: item?.url,
            deepLinkUrl: item?.deepLinkUrl,
          })
        })
        const withTermOfUse = [
          {
            message: welcomeMessage
          },
          {
            hasTermsOfUse: true,
          }
        ]
        newChatHistory.push(...withTermOfUse)
      }

      let newMessages = [];

      if (response) {
        newMessages = [{
          message: response,
          products: recommendedProducts,
          outgoing: false,
          deepLinkUrl,
          url
        }]
      }

      if (quickMessageList?.length > 0) {
        newMessages = [{
          message: welcomeMessage
        }, {
          message: 'Aşağıdaki örnek sorulardan birini seçebilirsin veya kendi sorunu yazabilirsin.',
          quickMessageList: quickMessageList || [],
        },
        {
          hasTermsOfUse: true,
        }];
      }

      newState = {
        ...state,
        ...chatHistory?.length > 0 ? {chatHistory: newChatHistory} : {},
        messages: [
          ...state.messages,
          ...newMessages
        ],
        isWriting: false,
        isButtonLoading: false,
      };
      break;
    }
    case 'SEND_MESSAGE_REJECTED': {
      const lastMessage = state.messages[state.messages.length - 1]
      const newMessage = {
        message: '',
        sentMessage: lastMessage?.message,
        isError: true
      }

      newState = {
        ...state,
        messages: [
          ...state.messages,
          newMessage
        ],
        isWriting: false,
        isError: true,
        isButtonLoading: false,
      };
      break;
    }

    case 'DELETE_CHAT': {
      newState = {
        ...state,
        chatHistory: [],
        messages: [],
        error: '',
        isLoading: true,
      };
      break;
    }

    case 'DELETE_CHAT_FULFILLED': {
      newState = {
        ...state,
        isDeleted: true,
        isLoading: false,
      };
      break;
    }

    case 'APPROVE_CONTRACT': {
      newState = {
        ...state,
        contractApproved: true,
      };
      break
    }

    case 'SET_TERMS_OF_USE_MODAL': {
      newState = {
        ...state,
        isTermsOfUseModalOpen: action.payload.value,
      };
      break
    }

    case 'CLEAR_ERROR': {
      newState = {
        ...state,
        error: '',
      };
      break
    }

    default:
      newState = state;
  }

  return newState;
}

export default shoppingAssistantReducer;

export {
  generateDefaultInitialShoppingAssistantState,
};
